import * as React from 'react';
import { Pagination as MPagination, type PaginationProps } from '@mui/material';

export const Pagination: React.FunctionComponent<PaginationProps> = (
  props: PaginationProps,
) => {
  const { ...rest } = props;

  return (
    <MPagination
      {...rest}
      shape="rounded"
      sx={{
        '& .MuiPaginationItem-root.Mui-selected': {
          backgroundColor: '#951d1d',
          color: 'white',
        },
        '& .MuiPaginationItem-root.Mui-selected:hover': {
          backgroundColor: '#951d1d',
        },
        '& .MuiPaginationItem-root:hover': {
          backgroundColor: '#FFF4F4',
        },
      }}
    />
  );
};
